<template lang="html">
  <header class="header-box">
    <div class="header-menu">
      <nav class="level">
        <figure class = "page-logo">
          <router-link to = "/">
            <!-- <div class="image-container">
              <img id="image01" src="https://naoto.nkmr.io/images/ken3Page_logo.png">
              <img id="image02" src="https://naoto.nkmr.io/images/ken3Page_logoBlack.png">
            </div> -->
            KEN3s PAGE
          </router-link>
        </figure>
        <p class="level-item has-text-centered">
          <router-link to = "/news">NEWS</router-link>
        </p>
        <p class="level-item has-text-centered">
          <router-link to = "/about">ABOUT</router-link>
        </p>
        <p class="level-item has-text-centered">
          <router-link to = "/research">RESEARCH</router-link>
        </p>
        <p class="level-item has-text-centered">
          <router-link to = "/works">WORKS</router-link>
        </p>
        <p class="level-item has-text-centered">
          <router-link to = "/diary">DIARY</router-link>
        </p>
        <p class="level-item has-text-centered">
          <router-link to = "/contact">CONTACT</router-link>
        </p>
        <p class="level-item-sub has-text-centered">
          <icons />
        </p>
      </nav>
    </div>
    <div class="menuBox">
      <Slide
        class="slideMenu"
        width="200"
      >
        <!-- <router-link to="/" tag="li">
          Top
        </router-link>
        <router-link to="/about" tag="li">
          About
        </router-link> -->
        <router-link to = "/">
          <!-- <figure class = "page-logo">
            <img src="https://naoto.nkmr.io/images/ken3Page_logo.png">
          </figure> -->
          KEN3s PAGE
        </router-link>
        <router-link to = "/news">
          <p class="level-item has-text-centered">
            NEWS
          </p>
        </router-link>
        <router-link to = "/about">
          <p class="level-item has-text-centered">
            ABOUT
          </p>
        </router-link>
        <router-link to = "/research">
          <p class="level-item has-text-centered">
            RESEARCH
          </p>
        </router-link>
        <router-link to = "/works">
          <p class="level-item has-text-centered">
            WORKS
          </p>
        </router-link>
        <router-link to = "/diary">
          <p class="level-item has-text-centered">
          DIARY
          </p>
        </router-link>
        <router-link to = "/contact">
          <p class="level-item has-text-centered">
            CONTACT
          </p>
        </router-link>
        <div class="menu-icons">
          <icons/>
        </div>
      </Slide>
    </div>
  </header>
</template>

<script>
import icons from '@/components/icons.vue'
import { Slide } from 'vue-burger-menu'

export default {
  components: {
    icons,
    Slide
  },
  mounted() {
    window.addEventListener('scroll', () => {
      var header = document.querySelector(".header-menu");
      header.classList.toggle("scroll-nav", window.scrollY > 40);
      // if(window.scrollY > 40){
      //   $('#image02').css('opacity', op.toString());
      // } else {
      //   $('#image01').css('opacity', op.toString());
      // }
    });
  }
}
</script>

<style lang="css" scoped>

.header-menu {
  display: block;
}
.menuBox {
  display: none;
}

.header-menu {
  transition: background-color 0.7s;
  position: fixed;
  width: 100vw;
  height: 75px;
  top: 0;
  background-color: none;
  /* background: rgba(0, 0, 0, 0.5); */
  /* background: 0.7; */
  z-index: 10;
}

.header-menu.scroll-nav {
  background-color: #f0f0f0;
  opacity: 1;
  z-index: 10;
}

.header-menu a {
  color: #FFF;
  font-weight: bold;
}

.header-menu.scroll-nav a {
  transition: color 0.7s;
  color: #303030;
  font-weight: bold;
}

.header-menu a:hover, .menuBox a:hover {
  transition: color 0.2s;
  font-weight: bold;
  color: #B7B7B7;
}

.header-box.scroll-nav .header-box a:hover, .menuBox a:hover {
  transition: color 0.2s;
  color: #979797;
  font-weight: bold;
}


@media(max-width: 1000px){
  .header-menu {
    display: none;
  }
  .menuBox {
    display: block;
  }

  .header-box {
    background-color: transparent;
  }
}

.level {
  position: relative;
  width: 80vw;
  height: 75px;
  margin: 0 auto;
}

.page-logo {
  width: 130px;
  margin: auto;
}

.menuBox {
  position: fixed;
  left: -17px;
  top: 40px;
  z-index: 100;
}

.menuBox p {
  text-align: center;
}

.menuBox a {
  font-weight: bold;
  color: #e0e0e0;
}

.bm-burger-button {
  position: relative;
  top: 0;
  width: 100px;
}
.bm-item-list {
  position: relative;
  width: 100%;
  color: #b8b7ad;
  left: -17px;
  margin-top: 20px;
  margin: 0 auto;
  font-size: 20px;
  cursor: pointer;
}
.bm-item-list > *:hover {
  background-color: #707070;
}

/* .image-container img {
  background: #D8D8D8;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
} */

/* #image01 {
  z-index: 9;
  opacity: 1.0;
}

#image02 {
  z-index: 8;
  opacity: 1.0;
} */

</style>
